import { EARLY_ACCESS_TO_NEW_IN } from "../../state/modules/category/constants";

const shouldShowModal = ({
  loyaltyBenefitType,
  loyaltyIsEnabled,
  loyaltyIsOptedIn,
  loyaltyNewInExperimentEnabled
}) => {
  const isEnabledCategory = loyaltyBenefitType === EARLY_ACCESS_TO_NEW_IN;

  if (loyaltyNewInExperimentEnabled && isEnabledCategory) {
    return false;
  }

  return loyaltyIsEnabled && isEnabledCategory && !loyaltyIsOptedIn;
};

export default shouldShowModal;
